import {useParams} from "react-router-dom";
import {useContext, useEffect, useState} from "react";
import VerificaDocumentoView from "./VerificaDocumentoView";
import {LoaderContext} from "../../context/LoaderContext";
import {getDocumentoFirmato2Api} from "../../services/CertificatiServices";

export default function VerificaDocumentoController() {
    const {idCertificato} = useParams()

    const [documento, setDocumento] = useState();
    const [loading, setLoading] = useState(true);

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    async function getDocumento() {
        startChiamata();
        const response = await getDocumentoFirmato2Api(idCertificato);
        endChiamata();
        setDocumento(response.data.data);
        setLoading(false);
    }

    useEffect(() => {
        getDocumento();
    }, [idCertificato]);

    return (
        !loading &&
        <VerificaDocumentoView
            documento={documento}
        />
    );

}